import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/taobao-mini-program"
    path="business/services/taobao-mini-program"
    element={<AsyncPage />}
  />,
];
